import { useEffect, useState } from 'react'
import { initiales, sousTitreProfil, type MonProfil } from '../api/operations'
import { Icone } from './Icone'
import { LogoSombre } from './Icone'
import { Navigation, type DefinitionEcran, type IdEcran } from './Navigation'

const CLE_REPLI = 'sd_sidebar'

export function BarreLaterale({
  actif,
  ecrans,
  surChangement,
  enAttente,
  nonLus,
  alertes,
  profil,
  nomOrg,
  surDeconnexion,
}: {
  actif: IdEcran
  ecrans: readonly DefinitionEcran[]
  surChangement: (id: IdEcran) => void
  enAttente: number
  nonLus: number
  /** Alertes GPS à traiter (0052). */
  alertes: number
  profil: MonProfil | null
  nomOrg: string
  surDeconnexion: () => void
}) {
  /* Le repli de la barre est une préférence de poste, pas une donnée : il vit
     dans le navigateur. Une lecture qui échoue (navigation privée, stockage
     bloqué) ne doit pas empêcher la console de s'afficher. */
  const [replie, setReplie] = useState(() => {
    try {
      return localStorage.getItem(CLE_REPLI) === '1'
    } catch {
      return false
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(CLE_REPLI, replie ? '1' : '0')
    } catch {
      /* Sans persistance, la préférence vaut pour la session — pas de quoi échouer. */
    }
    document.getElementById('app')?.classList.toggle('sb-collapsed', replie)
  }, [replie])

  return (
    <aside className="sidebar">
      <div className="sb-brand">
        <span className="logo-badge" id="logo-side">
          <LogoSombre />
        </span>
        <div className="brand-wm">
          <span className="sw">Swift</span>
          <span className="dl">Deliver</span>
        </div>
        <button
          className="sb-toggle"
          onClick={() => setReplie((v) => !v)}
          title="Réduire / agrandir le menu"
          aria-label="Réduire le menu"
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
      </div>

      <div className="sb-tenant">
        <div className="t-name">{nomOrg}</div>
        <div className="t-mgr">Console opérateur · offre Opérée</div>
      </div>

      <Navigation ecrans={ecrans} actif={actif} surChangement={surChangement} enAttente={enAttente} nonLus={nonLus} alertes={alertes} />

      <div className="sb-foot">
        {/* Le vrai profil connecté — voir `monProfil()` : l'original affichait
            un nom de maquette identique pour tout le monde. */}
        <div className="sb-user">
          <div className="sb-avatar">{profil ? initiales(profil.nom) : '—'}</div>
          <div>
            <div className="u-name">{profil?.nom ?? '…'}</div>
            <div className="u-role">{profil ? sousTitreProfil(profil) : ''}</div>
          </div>
        </div>
        <button className="sb-logout" onClick={surDeconnexion}>
          <span className="lo-ic">
            <Icone nom="logout" />
          </span>{' '}
          <span className="lo-txt">Se déconnecter</span>
        </button>
      </div>
    </aside>
  )
}
